import { Component, OnInit, OnDestroy, Input, ViewChild, TemplateRef, Output, EventEmitter } from '@angular/core';
import { NgxPowerBiService } from 'ngx-powerbi';
import { models } from 'powerbi-client';
import { Observable, Subscription } from 'rxjs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-pbi-report-view',
  templateUrl: './pbi-report-view.component.html',
  styleUrls: ['./pbi-report-view.component.scss']
})
export class PbiReportViewComponent implements OnInit, OnDestroy {
  @Input() openModal: Observable<any>;
  @Input() updateFilter?: Observable<any>;
  @Input() showFooter: boolean;
  @Input() showFilter: boolean;
  @Input() showPages: boolean;
  @Input() workspaceId: string;
  @Input() reportId: string;
  @Input() title?: string;
  @Input() selectObject?: boolean;
  @Output() rendered = new EventEmitter<boolean>();
  @Output() filters = new EventEmitter<any>();
  @Output() objectSelected = new EventEmitter<any>();
  @ViewChild('modalShowEbed', null) templateRef: TemplateRef<any>;

  private eventsSubscriptionOpen?: Subscription;
  private eventsSubscriptionFilter?: Subscription;
  private pbiContainerElement: HTMLElement;
  private report;
  public currentObject:string='';
  public currentTitle:string='';
  public currentType:string='';

  constructor(private powerBiService: NgxPowerBiService,  private modalService: NgbModal) { }

  // Load control is necessary to avoid setting filters before the report is ready.
  private hasLoaded = false;
  private loadResolve?: (value?: {} | PromiseLike<{}>) => void;
  private loadPromise?: Promise<{}>;

  setRendered(status: boolean) {
    this.rendered.emit(status);
  }

  ngOnInit() {
    if (!this.openModal) {
      throw new Error('Open modal event is required');
    }
    this.eventsSubscriptionOpen = this.openModal.subscribe((data) => {
      this.setRendered(false);
      this.modalService.open(this.templateRef);
      this.setReport(data);
    });
    if (this.updateFilter) {
      this.eventsSubscriptionFilter = this.updateFilter.subscribe((data) => {
        this.setFilters(data);
      });
    }
  }

  setReport(data) {
    this.pbiContainerElement = (document.getElementById('pbi-content')) as HTMLElement;
    const config: any = {
        type: 'report',
        tokenType: models.TokenType.Embed,
        accessToken: data.token,
        embedUrl: data.embedUrl,
        id: data.id,
        permissions: models.Permissions.All,
        settings: {
          filterPaneEnabled: this.showFilter,
          navContentPaneEnabled: this.showPages
        }
      };
    if (data.page) {
      config.pageName = data.page;
    }
    this.hasLoaded = false;
    this.loadPromise = new Promise(resolve => {
      this.loadResolve = resolve;
    });
    this.report = this.powerBiService.embed(this.pbiContainerElement, config);
    this.report.on('loaded', this.onLoad.bind(this));
    this.report.on('rendered', this.onRendered.bind(this));
    if(this.selectObject){
      this.report.on('visualClicked', async (t) => {

        console.log(t);
        var pages = await this.report.getPages();
        var page = pages.filter(i => i.isActive).shift();
        var visuals = await page.getVisuals();
        var visual = visuals.filter(i => i.name == t.detail.visual.name).shift();
        this.currentTitle = visual.title;
        this.currentType = t.detail.visual.type;
        /*
        debugger;
        window.document.querySelector(`[aria-describedby="visualsEnterHint-${t.detail.visual.name}"] .vcMenuBtn`).click();
        document.querySelector('.pbi-glyph-flashlight').click();
        */
        this.currentObject = t.detail.visual.name;

        /*
        document.querySelector('[aria-describedby="visualsEnterHint-"+t.detail.visual.name] .vcMenuBtn').click()
document.querySelector('.pbi-glyph-flashlight').click()
        */
        })
    }
  }

  onLoad() {
    this.hasLoaded = true;
    if (this.loadResolve) {
      this.loadResolve();
    }
  }

  onRendered() {
    this.setRendered(true);
    //this.report.getPages().then((pages: any[]) => console.log('data', pages));
  }

  enableFilter() {
    this.report.updateSettings({
      filterPaneEnabled: true
    });
  }

  disableFilter() {
    this.report.updateSettings({
      filterPaneEnabled: false
    });
  }

  async getFilters() {
    return await this.report.getFilters();
  }

  async setFilters(filters) {
    if (!this.hasLoaded) {
      // console.log("Caught filter change before it is ready to receive filter");
      await this.loadPromise;
    }
    await this.report.setFilters(filters);
  }

  async addFilters(filter) {
    const filters: Array<any> = await this.getFilters();
    filters.push(filter);
    await this.report.setFilters(filters);
  }

  async emitGetFilter(object: any) {
    this.filters.emit(await this.getFilters());
    object.close('saindo');
  }

  async emitSelectObject(object: any) {
    this.objectSelected.emit({
      objectId: this.currentObject,
      title:this.currentTitle
    });

    this.currentObject = "";
    this.currentTitle = "";
    this.currentType = "";
    object.close('saindo');
  }

  getTitle() {
    if (typeof this.title === 'string') {
      return this.title;
    }
    return this.showFooter  && !this.selectObject? 'Configure Filters' : this.selectObject?'Select Chart': 'View Report';
  }

  ngOnDestroy() {
    if (this.eventsSubscriptionOpen) {
      this.eventsSubscriptionOpen.unsubscribe();
    }
    if (this.eventsSubscriptionFilter) {
      this.eventsSubscriptionFilter.unsubscribe();
    }
  }

}
